(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["puffri-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('puffri-product-gallery')) {
    class PuffriProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        if (!this.viewport || this.slides.length < 2) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.thumbnails = [...this.querySelectorAll('[data-gallery-index]')];
        this.thumbnailList = this.querySelector('[data-gallery-thumbnails]');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.counter = this.querySelector('[data-gallery-counter]');
        this.index = this.visibleIndex();
        this.targetIndex = null;
        this.width = this.viewport.clientWidth;
        this.previous.hidden = false;
        this.next.hidden = false;
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('[data-gallery-index]');
          if (thumbnail && this.contains(thumbnail)) {
            event.preventDefault();
            this.goTo(Number(thumbnail.dataset.galleryIndex), 'instant');
          } else if (event.target.closest('[data-gallery-previous]')) {
            this.goTo((this.targetIndex ?? this.index) - 1);
          } else if (event.target.closest('[data-gallery-next]')) {
            this.goTo((this.targetIndex ?? this.index) + 1);
          }
        }, { signal });
        this.viewport.addEventListener('keydown', event => {
          const destination = this.keyboardDestination(event.key, this.targetIndex ?? this.index);
          if (destination === null) return;
          event.preventDefault();
          this.goTo(destination);
        }, { signal });
        this.thumbnailList.addEventListener('keydown', event => {
          const thumbnail = event.target.closest('[data-gallery-index]');
          if (!thumbnail) return;
          const destination = this.keyboardDestination(event.key, Number(thumbnail.dataset.galleryIndex));
          if (destination === null) return;
          event.preventDefault();
          const index = this.clamp(destination);
          this.goTo(index, 'instant');
          this.thumbnails[index].focus({ preventScroll: true });
        }, { signal });
        this.viewport.addEventListener('scroll', () => {
          if (this.targetIndex === null) {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.setActive(this.visibleIndex()));
          }
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.finishScroll(), 160);
        }, { passive: true, signal });
        this.viewport.addEventListener('scrollend', () => this.finishScroll(), { signal });
        for (const eventName of ['pointerdown', 'wheel', 'touchstart']) {
          this.viewport.addEventListener(eventName, () => { this.targetIndex = null; }, { passive: true, signal });
        }
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (width > 0 && width !== this.width) {
            this.width = width;
            this.goTo(this.targetIndex ?? this.index, 'instant');
          }
        });
        this.resizeObserver.observe(this.viewport);
        this.setActive(this.index, true);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.settleTimer);
      }
      clamp(index) {
        return Math.max(0, Math.min(this.slides.length - 1, index));
      }
      visibleIndex() {
        return this.clamp(Math.round(this.viewport.scrollLeft / Math.max(1, this.viewport.clientWidth)));
      }
      keyboardDestination(key, index) {
        if (key === 'ArrowLeft') return index - 1;
        if (key === 'ArrowRight') return index + 1;
        if (key === 'Home') return 0;
        if (key === 'End') return this.slides.length - 1;
        return null;
      }
      goTo(index, behavior) {
        const destination = this.clamp(index);
        this.targetIndex = destination;
        this.setActive(destination, true);
        const motion = behavior ?? (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
        this.viewport.scrollTo({ left: destination * this.viewport.clientWidth, behavior: motion });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.finishScroll(), 160);
      }
      finishScroll() {
        clearTimeout(this.settleTimer);
        this.targetIndex = null;
        this.setActive(this.visibleIndex(), true);
      }
      setActive(index, force = false) {
        if (!force && index === this.index) return;
        this.index = index;
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.slides.length - 1;
        const text = this.counter.dataset.counterTemplate.replace('__INDEX__', String(index + 1));
        if (this.counter.textContent !== text) this.counter.textContent = text;
        this.thumbnails.forEach((thumbnail, number) => {
          if (number === index) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
        const thumbnail = this.thumbnails[index];
        const left = thumbnail.offsetLeft;
        const right = left + thumbnail.offsetWidth;
        if (left < this.thumbnailList.scrollLeft) this.thumbnailList.scrollLeft = left;
        else if (right > this.thumbnailList.scrollLeft + this.thumbnailList.clientWidth) this.thumbnailList.scrollLeft = right - this.thumbnailList.clientWidth;
      }
    }
    customElements.define('puffri-product-gallery', PuffriProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
